"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _genericPopup = _interopRequireDefault(require("../generic-popup/generic-popup"));

var _button = _interopRequireDefault(require("./button.shape"));

var _buttons = require("../buttons");

var _buttonTypes = _interopRequireDefault(require("./button-types"));

class MessagePopup extends _react.Component {
  /**
   * Returns button component by button type
   * @param {string} type
   * @returns {Button}
   */
  getButtonByType(type) {
    switch (type) {
      case _buttonTypes.default.PRIMARY:
        return _buttons.PrimaryButton;

      case _buttonTypes.default.WHITE:
        return _buttons.WhiteButton;

      case _buttonTypes.default.RED:
        return _buttons.RedButton;

      default:
        return _buttons.PrimaryButton;
    }
  }

  renderButtons() {
    const {
      buttons
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "message-popup__buttons"
    }, buttons.map(button => {
      const {
        value,
        name,
        onClick,
        type,
        disabled,
        isLoading
      } = button;
      const Button = this.getButtonByType(type);
      return /*#__PURE__*/_react.default.createElement(Button, {
        onClick: onClick,
        key: value,
        className: (0, _classnames.default)('message-popup__button', "message-popup__button--".concat(value)),
        disabled: disabled,
        isLoading: isLoading
      }, name);
    }));
  }

  render() {
    const {
      title,
      onClose,
      children,
      className,
      style,
      hasClose,
      buttons
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_genericPopup.default, {
      onClose: onClose,
      hasClose: hasClose,
      className: (0, _classnames.default)('message-popup', className),
      style: style
    }, title && /*#__PURE__*/_react.default.createElement("div", {
      className: "message-popup__title"
    }, title), children && /*#__PURE__*/_react.default.createElement("div", {
      className: "message-popup__description"
    }, children), buttons && this.renderButtons());
  }

}

(0, _defineProperty2.default)(MessagePopup, "propTypes", {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onClose: _propTypes.default.func,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.default.object,
  hasClose: _propTypes.default.bool,
  buttons: _propTypes.default.arrayOf(_button.default)
});
(0, _defineProperty2.default)(MessagePopup, "defaultProps", {
  onClose: () => {},
  children: null,
  title: null,
  className: '',
  style: {},
  hasClose: true,
  buttons: null
});
var _default = MessagePopup;
exports.default = _default;